import { render, staticRenderFns } from "./Programs.vue?vue&type=template&id=1743c2d0&scoped=true&"
import script from "./Programs.vue?vue&type=script&lang=ts&"
export * from "./Programs.vue?vue&type=script&lang=ts&"
import style0 from "./Programs.vue?vue&type=style&index=0&id=1743c2d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1743c2d0",
  null
  
)

export default component.exports